"use strict";

var _defineProperty = require("/home/circleci/project/workspaces/frontend/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/defineProperty");

var _exports$BrandDomainM, _exports$BrandDomainM2;

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getBrandDeepLink = exports.getRBIDomain = exports.getDomain = exports.getBrandDomain = exports.BrandDeepLinkPrefix = exports.Tld = exports.Domains = exports.BrandDomainMapProd = exports.BrandDomainMapDev = void 0;

var brand_1 = require("./brand");

var country_code_1 = require("./country-code");

var platform_1 = require("./platform");

var stage_1 = require("./stage");

exports.BrandDomainMapDev = (_exports$BrandDomainM = {}, _defineProperty(_exports$BrandDomainM, brand_1.Brand.BK, 'https://dev.web.bk.rbi.tools/'), _defineProperty(_exports$BrandDomainM, brand_1.Brand.LTW, 'https://dev.web.ltw.rbi.tools/'), _defineProperty(_exports$BrandDomainM, brand_1.Brand.PLK, 'https://dev.web.plk.rbi.tools/'), _defineProperty(_exports$BrandDomainM, brand_1.Brand.TH, 'https://dev.web.th.rbi.tools/'), _exports$BrandDomainM);
exports.BrandDomainMapProd = (_exports$BrandDomainM2 = {}, _defineProperty(_exports$BrandDomainM2, brand_1.Brand.BK, 'https://www.bk.com/'), _defineProperty(_exports$BrandDomainM2, brand_1.Brand.LTW, ''), _defineProperty(_exports$BrandDomainM2, brand_1.Brand.PLK, 'https://www.popeyes.com/'), _defineProperty(_exports$BrandDomainM2, brand_1.Brand.TH, 'https://timhortons.ca/'), _exports$BrandDomainM2);
var Domains;

(function (Domains) {
  Domains["BK"] = "www.bk.com";
  Domains["BK_GB"] = "www.burgerking.co.uk";
  Domains["BK_CA"] = "www.burgerking.ca";
  Domains["BK_CH"] = "www.burger-king.ch";
  Domains["BK_ZA"] = "www.burgerking.co.za";
  Domains["BK_DE"] = "www.burgerking.de";
  Domains["LTW"] = "";
  Domains["PLK"] = "www.popeyes.com";
  Domains["PLK_CA"] = "www.popeyeschicken.ca";
  Domains["PLK_CH"] = "www.popeyeschicken.ch";
  Domains["TH_CA"] = "www.timhortons.ca";
  Domains["TH_US"] = "www.timhortons.com";
})(Domains = exports.Domains || (exports.Domains = {}));

var Tld;

(function (Tld) {
  Tld["US"] = "com";
  Tld["CA"] = "ca";
  Tld["GB"] = "co.uk";
  Tld["CH"] = "ch";
  Tld["ZA"] = "co.za";
  Tld["DE"] = "de";
})(Tld = exports.Tld || (exports.Tld = {}));

var BrandDeepLinkPrefix;

(function (BrandDeepLinkPrefix) {
  BrandDeepLinkPrefix["BK"] = "burgerking://";
  BrandDeepLinkPrefix["LTW"] = "ltw://";
  BrandDeepLinkPrefix["PLK"] = "popeyes://";
  BrandDeepLinkPrefix["TH"] = "timhortons://";
})(BrandDeepLinkPrefix = exports.BrandDeepLinkPrefix || (exports.BrandDeepLinkPrefix = {}));
/**
 * Get the domain for given brand in given environment.
 * @deprecated use getDomain or getRBIDomain instead
 *
 * @param {IGetBrandDomain} options
 * * brand - the brand whose domain is needed.
 * * environment - the environment to look up domain in.
 *
 * @returns {string} The domain for the brand found in the environment lookup.
 */


exports.getBrandDomain = function (_ref) {
  var brand = _ref.brand,
      environment = _ref.environment;
  return environment === stage_1.Stage.prod || environment === stage_1.Stage.qa ? exports.BrandDomainMapProd[brand] : exports.BrandDomainMapDev[brand];
};
/**
 * Return the production domain for the configured brand
 */


exports.getDomain = function (brand, locale, platform) {
  var normalizedLocale = (locale.region || '').toUpperCase();

  switch (brand) {
    case brand_1.Brand.BK:
      switch (normalizedLocale) {
        case country_code_1.IsoCountryCode2Char.GB:
          return Domains.BK_GB;

        case country_code_1.IsoCountryCode2Char.CA:
          return Domains.BK_CA;

        case country_code_1.IsoCountryCode2Char.CH:
          return Domains.BK_CH;

        case country_code_1.IsoCountryCode2Char.DE:
          return Domains.BK_DE;

        case country_code_1.IsoCountryCode2Char.ZA:
          return Domains.BK_ZA;

        case country_code_1.IsoCountryCode2Char.US:
        default:
          return Domains.BK;
      }

    case brand_1.Brand.LTW:
      return Domains.LTW;

    case brand_1.Brand.TH:
      if (platform === platform_1.Platform.app) {
        return Domains.TH_CA;
      }

      return locale.region === country_code_1.IsoCountryCode2Char.US ? Domains.TH_US : Domains.TH_CA;

    case brand_1.Brand.PLK:
      switch (locale.region) {
        case country_code_1.IsoCountryCode2Char.CA:
          return Domains.PLK_CA;

        case country_code_1.IsoCountryCode2Char.US:
          return Domains.PLK;

        case country_code_1.IsoCountryCode2Char.CH:
          return Domains.PLK_CH;
      }

  }

  return Domains.PLK;
};
/**
 * Return the rbi development domain for the configured brand and stage.
 * @param brand
 * @param locale
 */


exports.getRBIDomain = function (brand, stage, locale) {
  var normalizedLocale = (locale.region || '').toUpperCase();
  var tld;

  switch (normalizedLocale) {
    case country_code_1.IsoCountryCode2Char.US:
      tld = Tld.US;
      break;

    case country_code_1.IsoCountryCode2Char.CA:
      tld = Tld.CA;
      break;

    case country_code_1.IsoCountryCode2Char.GB:
      tld = Tld.GB;
      break;

    case country_code_1.IsoCountryCode2Char.DE:
      tld = Tld.DE;
      break;

    case country_code_1.IsoCountryCode2Char.CH:
      tld = Tld.CH;
      break;

    case country_code_1.IsoCountryCode2Char.ZA:
      tld = Tld.ZA;
      break;

    default:
      throw new Error("Unsupported country code ".concat(normalizedLocale));
  }

  return "".concat(stage, "-").concat(brand.toLowerCase(), "-web.").concat(tld, ".rbi.tools");
};
/**
 * Get the deep link prefix for given brand in given environment.
 *
 * @param {IGetDeepLink} options
 * * brand - the brand whose prefix is needed.
 * * stage - the environment to look up prefix in.
 *
 * @returns {string} The prefix for the brand found in the environment lookup.
 */


exports.getBrandDeepLink = function (_ref2) {
  var brand = _ref2.brand;
  return BrandDeepLinkPrefix[brand];
};